module.exports = __webpack_public_path__ + "img/video-3.0fecd431.png";